import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'

import LButton from '@/components/core/Button.vue'
import LInput from '@/components/core/form/Input.vue'
import DatePicker from '@/components/core/DatePicker.vue'
import { formattedDate } from '@/utils/date-utils'
import { useContext } from '@/composables/context'
import { eventModule } from '@/store'
import { FlightDetailsNew } from '@/types/transportation'


export default /*#__PURE__*/_defineComponent({
  __name: 'FlightLookup',
  props: {
    prefilledDepartureDate: null
  },
  emits: ["flight-found", "manual-entry"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'flight-found', flightDetails: FlightDetailsNew): void
  (
    e: 'manual-entry',
    flightDetails: {
      flightNumber?: string
      departureDate?: string
    },
  ): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  prefilledDepartureDate?: string
};





const { $axios } = useContext()

const flightNumber = ref('')
const departureDate = ref(props.prefilledDepartureDate ?? '')

const isSearching = ref(false)

async function lookupFlight() {
  isSearching.value = true
  try {
    const { data } = await $axios.get<FlightDetailsNew>(
      `api/meta/flights/search`,
      {
        params: {
          flightNumber: flightNumber.value.toUpperCase(),
          departureDate: departureDate.value,
        },
      },
    )
    emit('flight-found', data)
  } catch (error) {
    eventModule.newInfo([
      'info.transportation.searchFlight',
      'noWorriesYouCanStillAddIt',
    ])
  } finally {
    isSearching.value = false
  }
}

return { __sfc: true,props, emit, $axios, flightNumber, departureDate, isSearching, lookupFlight, LButton, LInput, DatePicker, formattedDate }
}

})